module.exports = __webpack_public_path__ + "static/img/r_008.e76da04.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pic/r_008.jpg
// module id = a2gg
// module chunks = 1